import PropTypes from 'prop-types';
import { cn } from '@repo/zolintra-utils';
// Components
import { Icon, availableIcons } from '../Icon/Icon';
// Styles
// eslint-disable-next-line import/no-unresolved
import Loader from '../../../assets/icons/loader.svg?react';
import styles from './Button.module.css';

export function Button({
  color,
  shape,
  size,
  icon,
  iconPosition,
  variant,
  fontWeight,
  isLoading,
  children,
  className,
  onClick,
  disabled,
}) {
  return (
    <button
      className={cn([
        styles.button,
        styles[shape],
        styles[size],
        styles[variant],
        styles[fontWeight],
        styles[color],
        styles[`icon-${iconPosition}`],
        className,
      ])}
      type="button"
      onClick={onClick}
      disabled={disabled || isLoading}
    >
      {isLoading ? <Loader className={styles.loader} /> : null}
      {!isLoading && icon ? <Icon className={styles.icon} icon={icon} /> : null}
      {children}
    </button>
  );
}

Button.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node,
  color: PropTypes.oneOf(['transparent', 'primary500', 'primary200', 'neutral500', 'alert500']),
  shape: PropTypes.oneOf(['rectangle', 'rounded']),
  size: PropTypes.oneOf(['small', 'medium']),
  icon: PropTypes.oneOf(Object.keys(availableIcons)),
  iconPosition: PropTypes.oneOf(['right', 'left']),
  variant: PropTypes.oneOf(['filled', 'bordered']),
  fontWeight: PropTypes.oneOf(['regular', 'bold']),
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

Button.defaultProps = {
  children: null,
  color: 'primary500',
  shape: 'rounded',
  size: 'medium',
  icon: null,
  iconPosition: 'left',
  variant: 'filled',
  fontWeight: 'regular',
  isLoading: false,
  className: null,
  disabled: false,
};

export default Button;
